function AdsNinjaRefreshingAdZone(adElementId, refreshContainerElementId, data, prefetch, zoneName, zoneGroupName, minimumTimeBuffer, timeBuffer, pixelDistance, pixelTrigger, inview, logger){

    this.__data                         = data;
    this.__adElementId                  = adElementId; // TODO: This would change.
    this.__refreshContainerElementId    = refreshContainerElementId;
    this.__hasTransitionStarted         = false;
    this.__prefetch                     = prefetch;
    this.__zoneName                     = zoneName;
    this.__zoneGroupName                = zoneGroupName;
    this.__isNextAdSetup                = false;
    this.__pixelDistance                = pixelDistance;
    this.__pixelTrigger                 = pixelTrigger; // TODO: Fix this it's value doesn't match param name. Should be ignore pixel trigger.
    this.__ignorePixelTrigger           = pixelTrigger;
    this.__timeBuffer                   = timeBuffer;
    this.__inview                       = inview;
    this.__minimumTimeBuffer            = minimumTimeBuffer;
    this.inviewWaypoint                 = null;
    this.__maxRefresh                   = 11; //for 10 refreshed of the ad
    this.__logger                       = logger;
    this.__maxNotBidding                = 4;
    this.__prefetchTimeBuffer           = 28;
}


AdsNinjaRefreshingAdZone.prototype.createNextAdElementId = function(){

    var originalAdElementId = this.getOriginalAdElementId();

    if(!originalAdElementId){

        return null;
    }

    var refreshCount = this.incrementRefreshCount();

    var nextAdElementId = originalAdElementId + `-count-${refreshCount}`;

    this.setNextAdElementId(nextAdElementId);

    return nextAdElementId;
};

//
// Increments the refresh count by 1.
AdsNinjaRefreshingAdZone.prototype.incrementRefreshCount = function(){
    
    var refreshCount = Number(this.getRefreshCount());

    refreshCount++;

    this.setRefreshCount(refreshCount);

    return refreshCount;
};

AdsNinjaRefreshingAdZone.prototype.isReadyForRefresh = function(context){

    if('force' === context){

        return true;
    }

    var adZoneEventsLog = this.__getAdZoneEventsLog();
    //const brandWithNoRefreshCap = ["GiveMeSport", "XDA", "TheGamer", "MakeUseOf"];

    var $logMessage = "new refresh logic, check ready to refresh : " + this.__adElementId;

    if(!adZoneEventsLog || !adZoneEventsLog.isLoaded || !adZoneEventsLog.isViewed || !adZoneEventsLog.isMinimumTimerComplete || this.getHasTransitionStarted() || !this.isAllowedToRefresh()){

        this.__logger.debug('isReadyToRefresh conditions check', {
            adZoneEventsLog: adZoneEventsLog,
            hasTransitionStarted: this.getHasTransitionStarted(),
            isAllowedToRefresh: this.isAllowedToRefresh()
        });
        return false;
    }

    if(!this.isInView() && !adZoneEventsLog['forcedEvents']){

        $logMessage = $logMessage + " || Not Able to refresh because not in view";
        this.__logger.debug($logMessage);
        return false;
    }

    if(document.hidden){

        $logMessage = $logMessage + " || Not Able to refresh because document hidden or window not in focus || document hidden:" + document.hidden;
        this.__logger.debug($logMessage);
        return false;
    }
    
    switch(context){

        case 'autoRefresh':
            $logMessage = $logMessage + " || Auto Refresh is Done!";
            this.__logger.debug($logMessage);
            return (adZoneEventsLog.isTimerComplete);

            break;

        case 'minimumTime':
        case 'viewed':
        case 'inView':
        case 'noFill':
        case 'time':
        case 'float':
        case 'scroll':
        case 'delayedSetupNext':

            return (this.hasTimerRefresh() && adZoneEventsLog.isTimerComplete);

            break;
        
        case 'custom':
        case 'waypoint':
        case 'inBannerVideo':

        return true;

        break;
    }

    return false;
};

AdsNinjaRefreshingAdZone.prototype.isReadyForPrefetch = function(context = 'force'){


    if('force' === context){

        return true;
    }

    var adZoneEventsLog = this.__getAdZoneEventsLog();
    //const brandWithNoRefreshCap = ["GiveMeSport", "XDA", "TheGamer", "MakeUseOf"];

    var $logMessage = "new prefetch logic, check ready to prefetch : " + this.__adElementId;

    if(!adZoneEventsLog || !adZoneEventsLog.isLoaded || !adZoneEventsLog.isViewed || !adZoneEventsLog.isMinimumTimerComplete || !this.isAllowedToRefresh()){

        this.__logger.debug('isReadyToPrefetch conditions check', {
            adZoneEventsLog: adZoneEventsLog,
            isAllowedToRefresh: this.isAllowedToRefresh()
        });

        return false;
    }

    if(!this.isInView() && !adZoneEventsLog['forcedEvents']){

        $logMessage = $logMessage + " || Not Able to prefetch because not in view";
        this.__logger.debug($logMessage);
        return false;
    }

    if(document.hidden){

        $logMessage = $logMessage + " || Not Able to prefetch because document hidden or window not in focus || document hidden:" + document.hidden;
        this.__logger.debug($logMessage);
        return false;
    }
    
    switch(context){

        case 'autoRefresh':
            $logMessage = $logMessage + " || Auto prefetch is Done!";
            $logMessage = $logMessage + " || result: " + (adZoneEventsLog.isPrefetchTimeComplete);
            this.__logger.debug($logMessage);

            return (adZoneEventsLog.isPrefetchTimeComplete);

            break;

        case 'minimumTime':
        case 'viewed':
        case 'inView':
        case 'noFill':
        case 'time':
        case 'float':
        case 'scroll':
        case 'delayedSetupNext':
            $logMessage = $logMessage + " || time, inView, noFill, scroll, delayedSetupNext prefetch is checked!";
            $logMessage = $logMessage + " || result: " + (this.hasTimerRefresh() && adZoneEventsLog.isPrefetchTimeComplete);
            this.__logger.debug($logMessage);
            return (this.hasTimerRefresh() && adZoneEventsLog.isPrefetchTimeComplete);

            break;
        
        case 'custom':
        case 'waypoint':
        case 'inBannerVideo':

        $logMessage = $logMessage + " || custom, waypoint, inBanner prefetch is checked!";
        $logMessage = $logMessage + " || result: true";
        this.__logger.debug($logMessage);
        return true;

        break;
    }

    return false;
};

AdsNinjaRefreshingAdZone.prototype.__getAdZoneEventsLog = function(){

    return window.adsNinjaHeaderBiddingManager.adZoneEventsLog[this.__adElementId] || null;
};

AdsNinjaRefreshingAdZone.prototype.__getBrandName = function(){

    return window.adsNinjaHeaderBiddingManager.getBrandName();
};

AdsNinjaRefreshingAdZone.prototype.haveTimersStarted = function(){

    var adZoneEventsLog = this.__getAdZoneEventsLog();

    return (!adZoneEventsLog) ? false : adZoneEventsLog.haveTimersStarted;
};

AdsNinjaRefreshingAdZone.prototype.isTimerComplete = function(){

    var adZoneEventsLog = this.__getAdZoneEventsLog();

    return (!adZoneEventsLog) ? false : adZoneEventsLog.isTimerComplete;
};

AdsNinjaRefreshingAdZone.prototype.isMinimumTimerComplete = function(){

    var adZoneEventsLog = this.__getAdZoneEventsLog();

    return (!adZoneEventsLog) ? false : adZoneEventsLog.isMinimumTimerComplete;
};

AdsNinjaRefreshingAdZone.prototype.getRefreshContainerElement = function(){

    return document.getElementById(this.__refreshContainerElementId);
};

//
// Returns original ad element ID used by refreshing container.
AdsNinjaRefreshingAdZone.prototype.getOriginalAdElementId = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return null;
    }

    return refreshContainerElement.getAttribute('data-original-ad-element-id');
};

//
// Returns current ad element ID used by refreshing container.
AdsNinjaRefreshingAdZone.prototype.getCurrentAdElementId = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return null;
    }

    return refreshContainerElement.getAttribute('data-current-ad-element-id');
};

AdsNinjaRefreshingAdZone.prototype.setCurrentAdElementId = function(data){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        this.__logger.error('Missing refresh container element.', {
            adsNinjaRefreshingAdZone: this,
        });
        return;
    }

    refreshContainerElement.setAttribute('data-current-ad-element-id', data);

    // TODO: Cache.
    var zone = window.adsNinja.zoneDelegate.getByElementId(data);

    if(!zone){

        this.__logger.error('Zone not found!');

        return;
    }

    zone.setCurrentUnitElementId(data);
    zone.setNextUnitElementId(null);
};

AdsNinjaRefreshingAdZone.prototype.getNextAdElementId = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return null;
    }

    return refreshContainerElement.getAttribute('data-next-ad-element-id');
};

AdsNinjaRefreshingAdZone.prototype.setNextAdElementId = function(data){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        this.__logger.error('Missing refresh container element.', {
            adsNinjaRefreshingAdZone: this,
        });
        return;
    }

    refreshContainerElement.setAttribute('data-next-ad-element-id', data);
};

AdsNinjaRefreshingAdZone.prototype.getNotBiddingCount = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return null;
    }

    return Number(this.getRefreshContainerElement().getAttribute('data-not-bidding-count'));
};

AdsNinjaRefreshingAdZone.prototype.setNotBiddingCount = function(count){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        this.__logger.error('Missing refresh container element.', {
            adsNinjaRefreshingAdZone: this,
        });
        return;
    }

    this.getRefreshContainerElement().setAttribute('data-not-bidding-count', count);
};

AdsNinjaRefreshingAdZone.prototype.getRefreshCount = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return null;
    }

    return this.getRefreshContainerElement().getAttribute('data-refresh-count');
};

AdsNinjaRefreshingAdZone.prototype.setRefreshCount = function(count){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        this.__logger.error('Missing refresh container element.', {
            adsNinjaRefreshingAdZone: this,
        });
        return;
    }

    this.getRefreshContainerElement().setAttribute('data-refresh-count', count);
};

AdsNinjaRefreshingAdZone.prototype.getRefreshHeader = function(){

    return this.__data['headerTemplate'].replaceAll('DIR_AD_ELEMENT_ID', this.__adElementId);
};

AdsNinjaRefreshingAdZone.prototype.getRefreshContent = function(){

    if(!this.__data || !this.__data['contentTemplate']){

        this.__logger.error('Missing refresh content template.', {
            adsNinjaRefreshingAdZone: this,
        })
        return '';
    }

    return '<div class="ad-next" style="display: none;">' + this.__data['contentTemplate'].replaceAll('DIR_AD_ELEMENT_ID', this.__adElementId) + '</div>';
};

AdsNinjaRefreshingAdZone.prototype.getData = function(){

    return this.__data;
};

AdsNinjaRefreshingAdZone.prototype.getRefreshContainerElementId = function(){

    return this.__refreshContainerElementId;
};

AdsNinjaRefreshingAdZone.prototype.isInView = function(){

    var zone = window.adsNinja.zoneDelegate.getByElementId(this.__adElementId);

    return (zone) ? zone.isInView() : false;

    var ad = window.adsNinjaHeaderBiddingManager.__adsData[this.__adElementId];

    var currentAdElement = document.getElementById(this.__adElementId);

    if(!currentAdElement){

        this.__logger.warn(`Unable to find ad element with ID for in-view check: ${this.__adElementId}.`);

        return false;
    }

    var adZoneContainerElementId = `ad-zone-container-${this.__adElementId}`;
    var adZoneContainerElement   = document.getElementById(adZoneContainerElementId);

    if(!adZoneContainerElement){

        this.__logger.warn('Unable to toggle floating for ad zone: container element does not exist!', {
            adElementId: this.__adElementId,
            adZoneContainerElementId: adZoneContainerElementId,
        });
        return;
    }

    var adZoneElement = adZoneContainerElement.getElementsByClassName('ad-zone')[0];

    if(!adZoneElement){

        this.__logger.warn('Unable to toggle floating for ad zone: element does not exist in container!', {
            adElementId: this.__adElementId,
            adZoneContainerElementId: adZoneContainerElementId,
        });
        return;
    }

    if((adZoneElement.classList.contains('ad-zone-floating')) && 'always' === adZoneElement.getAttribute('data-floating-mode')){

        return true;
    }

    var rect       = currentAdElement.getBoundingClientRect();
    var rectTop    = rect.top;
    var restHeight = rect.height;
    var restWidth  = rect.width;
    var rectLeft   = rect.left;
    var scrollY    = window.scrollY;

    if(0 === rectTop
        && 0 === restHeight
        && 0 === restWidth
        && 0 === rectLeft
    ){

        var estimatedYPositionTop    = ad.getEstimatedYPositionTop();
        var estimatedYPositionBottom = ad.getEstimatedYPositionBottom();
        var estimatedXPositionLeft   = ad.getEstimatedXPositionLeft();
        var estimatedXPositionRight  = ad.getEstimatedXPositionRight();

        rectTop    = (!isNaN(estimatedYPositionTop)) ? estimatedYPositionTop - scrollY : 0;
        restHeight = (!isNaN(estimatedYPositionBottom)) ? estimatedYPositionBottom - scrollY - rectTop : 0;
        rectLeft   = (!isNaN(estimatedXPositionLeft)) ? estimatedXPositionLeft : 0;
        restWidth  = (!isNaN(estimatedXPositionRight)) ? estimatedXPositionRight - rectLeft : 0;
    }

    var percentageOfHeightInView = ((restHeight + rectTop) / restHeight) * 100;
    percentageOfHeightInView     = (isNaN(percentageOfHeightInView)) ? 0 : percentageOfHeightInView;
    var percentageOfWidthInView  = ((restWidth + rectLeft) / restWidth) * 100;
    percentageOfWidthInView      = (isNaN(percentageOfWidthInView)) ? 0 : percentageOfWidthInView;

    // Calculate with percentages of ad in view.
    var isInView = (
        percentageOfHeightInView >= 50
        && percentageOfWidthInView >= 50
        && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );

    return isInView;
};

AdsNinjaRefreshingAdZone.prototype.getHasTransitionStarted = function(){

    var adUnit = window.adsNinjaHeaderBiddingManager.getAdsData(this.__adElementId);

    if(adUnit.isRefreshModeRegular()){

        return false;
    }

    return this.__hasTransitionStarted;
};

AdsNinjaRefreshingAdZone.prototype.setHasTransitionStarted = function(value){

    this.__hasTransitionStarted = value;
};

AdsNinjaRefreshingAdZone.prototype.changeShownAdInContainer = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return;
    }

    // Delete waypoint.
    // if(this.inviewWaypoint){

    //     this.inviewWaypoint.destroy();

    //     this.inviewWaypoint = null;
    // }

    var currentAd     = refreshContainerElement.querySelector('.ad-current');
    var nextAd        = refreshContainerElement.querySelector('.ad-next');
    var currentAdData = window.adsNinjaHeaderBiddingManager.getAdsData(this.getCurrentAdElementId());
    var adZoneElement = currentAdData.getAdZoneElement();

    if(adZoneElement && adZoneElement.classList.contains('ad-zone-floating')){

        refreshContainerElement.style.visibility = 'hidden';
        currentAd.style.visibility               = 'hidden';
        nextAd.style.display                     = 'unset';
    }
    else{

        currentAd.style.display = 'none';
    }

    currentAd.classList.remove('ad-current');
    nextAd.classList.remove('ad-next');
    currentAd.classList.add('ad-previous');
    nextAd.classList.add('ad-current');

    var adUnit = window.adsNinjaHeaderBiddingManager.getAdsData(this.__adElementId);

    // Remove GPT reference of current ad.
    var result = this.removeGptReference();

    // Vendor specific close. Only do this when allowed, such as a sticky footer zone.
    if(adUnit.canRemoveVendorSpecificContainers()){

        this.__closeVendorSpecificContainers();
    }

    this.__logger.debug('Destroyed ad slot.', {
        didDestroy: result,
        adElementId: this.getCurrentAdElementId(),
    });

    this.setCurrentAdElementId(this.getNextAdElementId())
    this.setNextAdElementId('');
    
    // Delete old ad.
    currentAd.remove();

    currentAd = null;

    var adZoneContainerElementId = `ad-zone-container-${this.getCurrentAdElementId()}`;
    var adZoneContainerElement   = document.getElementById(adZoneContainerElementId);

    if(!adZoneContainerElement){

        this.__logger.warn('Unable to add loading animation: container element does not exist!', {
            adElementId: this.__adElementId,
            adZoneContainerElementId: adZoneContainerElementId,
        });
        return;
    }

    adZoneContainerElement.classList.add('ad-loading');
            
    if(adZoneElement.classList.contains('ad-zone-floating')){

        nextAd.style.visibility                  = 'visible';
        refreshContainerElement.style.visibility = 'visible';
    }
    else{

        nextAd.style.display = 'unset';
    }

    adUnit.removeCache();
};

//
// Sets class and attribute on the refresh container element.
AdsNinjaRefreshingAdZone.prototype.setNoFloatingAllowed = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return;
    }

    refreshContainerElement.classList.add('no-floating');
    refreshContainerElement.setAttribute('data-floating-allowed', 'false');
};

//
// Sets class and attribute on the refresh container element.
AdsNinjaRefreshingAdZone.prototype.setFloatingAllowed = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return;
    }

    refreshContainerElement.classList.remove('no-floating');
    refreshContainerElement.setAttribute('data-floating-allowed', 'true');
};

AdsNinjaRefreshingAdZone.prototype.isAllowedToFLoat = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return true;
    }
    
    return ('true' === refreshContainerElement.getAttribute('data-floating-allowed'));
};

AdsNinjaRefreshingAdZone.prototype.setNoRefreshingAllowed = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return;
    }

    refreshContainerElement.setAttribute('data-refreshing-allowed', 'false');
};

AdsNinjaRefreshingAdZone.prototype.setRefreshingAllowed = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return;
    }

    refreshContainerElement.setAttribute('data-refreshing-allowed', 'true');
};

AdsNinjaRefreshingAdZone.prototype.isAllowedToRefresh = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        return true;
    }

    return ('true' === refreshContainerElement.getAttribute('data-refreshing-allowed'));
};

//
// Disables pixel refreshers.
AdsNinjaRefreshingAdZone.prototype.disablePixelRefresher = function(){

    var originalAdElementId = this.getOriginalAdElementId();

    if(!originalAdElementId){

        this.__logger.error('Missing original ad element ID.', {
            adsNinjaRefreshingAdZone: this,
        });
        return;
    }

    if(window.adsNinjaHeaderBiddingManager.pixelRefreshers[originalAdElementId]){

        window.adsNinjaHeaderBiddingManager.pixelRefreshers[originalAdElementId].disable();
    }
};

//
// Enables pixel refreshers.
AdsNinjaRefreshingAdZone.prototype.enablePixelRefresher = function(){
    
    var originalAdElementId = this.getOriginalAdElementId();
    if(!originalAdElementId){
        
        this.__logger.error('Missing original ad element ID.', {
            adsNinjaRefreshingAdZone: this,
        });
        return;
    }
    if(window.adsNinjaHeaderBiddingManager.pixelRefreshers[originalAdElementId]){
        
        window.adsNinjaHeaderBiddingManager.pixelRefreshers[originalAdElementId].enable();
    }
};

//
// Removes pixel refreshers.
AdsNinjaRefreshingAdZone.prototype.removeScrollTimerRefresher = function(){

    // Delete scroll event listener.
    if(window[`scrollEventListener_${this.__adElementId}`]){

        document.removeEventListener('scroll', window[`scrollEventListener_${this.__adElementId}`], (window.adsNinjaHeaderBiddingManager.arePassiveEventListenersSupported()) ? { passive: true } : false);
    
        window[`scrollEventListener_${this.__adElementId}`] = null;
    }
};

//
// Destroys the slot managed by Google library.
AdsNinjaRefreshingAdZone.prototype.removeGptReference = function(){

    var currentAdElementId = this.getCurrentAdElementId();
    var gamAdSlot          = null;
    var slots              = window.googletag.pubads().getSlots();

    for(var x in slots){

        var slot = slots[x];

        if(currentAdElementId === slot.getSlotElementId()){

            gamAdSlot = slot;

            break;
        }
    }

    if(!gamAdSlot || 'object' !== typeof gamAdSlot){

        return false;
    }

    return window.googletag.destroySlots([gamAdSlot]);
};

//
// Removes ads from refresh container.
AdsNinjaRefreshingAdZone.prototype.removeRefreshContainerElementAds = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        this.__logger.error('Missing refresh container element.', {
            adsNinjaRefreshingAdZone: this,
        });
        return;
    }

    this.removeScrollTimerRefresher();

    var previousAd = refreshContainerElement.querySelector('.ad-previous');
    var currentAd  = refreshContainerElement.querySelector('.ad-current');
    var nextAd     = refreshContainerElement.querySelector('.ad-next');

    if(previousAd){
        
        refreshContainerElement.removeChild(previousAd);

        previousAd = null;
    }

    if(currentAd){
        
        refreshContainerElement.removeChild(currentAd);

        currentAd = null;
    }

    if(nextAd){

        refreshContainerElement.removeChild(nextAd);

        nextAd = null;
    }
};

AdsNinjaRefreshingAdZone.prototype.getZoneName = function(){

    return this.__zoneName;
};

AdsNinjaRefreshingAdZone.prototype.getZoneGroupName = function(){

    return this.__zoneGroupName;
};

AdsNinjaRefreshingAdZone.prototype.isAllowedToPrefetch = function(){

    return this.__prefetch;
};

AdsNinjaRefreshingAdZone.prototype.isNextAdSetup = function(){

    var adUnit = window.adsNinjaHeaderBiddingManager.getAdsData(this.__adElementId);

    if(adUnit.isRefreshModeRegular()){

        return false;
    }

    return this.__isNextAdSetup;
}

AdsNinjaRefreshingAdZone.prototype.setIsNextAdSetup = function(value){

    this.__isNextAdSetup = value;
}

AdsNinjaRefreshingAdZone.prototype.getMinimumTimeBuffer = function(){

    return this.__minimumTimeBuffer;
}

AdsNinjaRefreshingAdZone.prototype.getTimeBuffer = function(){

    return this.__timeBuffer;
}

AdsNinjaRefreshingAdZone.prototype.getPrefetchTimeBuffer = function(){

    return this.__prefetchTimeBuffer;
}

AdsNinjaRefreshingAdZone.prototype.setPrefetchTimeBuffer = function(prefetchTimeBuffer){

    this.__prefetchTimeBuffer = prefetchTimeBuffer;
}

AdsNinjaRefreshingAdZone.prototype.getPixelDistance = function(){

    return this.__pixelDistance;
}

AdsNinjaRefreshingAdZone.prototype.getPixelTrigger = function(){

    return this.__pixelTrigger;
}

AdsNinjaRefreshingAdZone.prototype.getInview = function(){

    return this.__inview;
}

AdsNinjaRefreshingAdZone.prototype.hasTimerRefresh = function(){

    return (!!this.__timeBuffer);
}

AdsNinjaRefreshingAdZone.prototype.hasPixelRefresh = function(){

    return (!(!!this.__ignorePixelTrigger) && !!this.__pixelDistance);
}

AdsNinjaRefreshingAdZone.prototype.hasInViewRefresh = function(){

    return (this.__inview);
}

AdsNinjaRefreshingAdZone.prototype.getMaxNotBidding = function(){

    return this.__maxNotBidding;
}

AdsNinjaRefreshingAdZone.prototype.hasMaxNotBiddingLimitBeenReached = function(){

    return (this.getNotBiddingCount() >= this.__maxNotBidding);
}

AdsNinjaRefreshingAdZone.prototype.resetNotBiddingCount = function(){

    var refreshContainerElement = this.getRefreshContainerElement();

    if(!refreshContainerElement){

        this.__logger.error('Missing refresh container element.', {
            adsNinjaRefreshingAdZone: this,
        });
        return;
    }

    this.getRefreshContainerElement().setAttribute('data-not-bidding-count', 0);
}

//
// Attempt to close banners that takeover sticky footer.
AdsNinjaRefreshingAdZone.prototype.__closeVendorSpecificContainers = function(){

    var removedKargo  = this.__closeContainerKargo();
    var removedGumGum = false;

    if(!removedKargo){

        removedGumGum = this.__closeContainerGumGum();
    }

    if(removedKargo || removedGumGum){

        this.__logger.debug('Removed vendor specific container.', {
            vendor: (removedKargo) ? 1 : 2,
        });
    }
}

//
// Attempt to close banners that takeover sticky footer.
AdsNinjaRefreshingAdZone.prototype.__closeContainerKargo = function(){

    // Use containers rather than buttons.
    var kargoContainerSearchResult = document.querySelectorAll('[class^="kargo-ad-v"]');

    if(kargoContainerSearchResult.length === 0){

        return false;
    }

    for(var x in kargoContainerSearchResult){

        var kargoContainer = kargoContainerSearchResult[x];

        // Validate that we are deleting the correct container. It should have been added to the body.
        if(!kargoContainer || !kargoContainer.parentElement || 'body' !== kargoContainer.parentElement.tagName.toLowerCase()){

            continue;
        }

        var kargoCloseButtonSearchResult = kargoContainer.querySelectorAll('.kargo-hover-close.filled');

        if(kargoCloseButtonSearchResult.length > 0){

            kargoContainer.remove();
            return true;
        }
    }

    return false;
}

//
// Attempt to close banners that takeover sticky footer.
AdsNinjaRefreshingAdZone.prototype.__closeContainerGumGum = function(){

    // Use containers rather than buttons.
    var gumGumCloseButtonSearchResult = document.querySelectorAll('[id^="ad_is_"][id$="_CLOSE"]');

    if(gumGumCloseButtonSearchResult.length > 0){

        var gumGumCloseButton    = gumGumCloseButtonSearchResult[0];
        var gumGumCloseButtonId  = gumGumCloseButton.id;

        if(!gumGumCloseButtonId){

            return false;
        }

        var containerId          = gumGumCloseButtonId.replace('_CLOSE','');
        var gumGumContainerInner = document.getElementById(containerId);

        if(!gumGumContainerInner){

            return false;
        }

        var gumGumContainer = gumGumContainerInner.parentElement;

        // Validate that we are deleting the correct container. It should have been added to the body.
        if(gumGumContainer && gumGumContainer.parentElement && 'body' === gumGumContainer.parentElement.tagName.toLowerCase()){

            gumGumContainerInner.remove();
            return true;
        }
    }

    return false;
}

//
// Set max prebid not bidding.
AdsNinjaRefreshingAdZone.prototype.setMaxNotBidding = function(maxNotBidding){
    
    this.__maxNotBidding = maxNotBidding;
}

window.AdsNinjaRefreshingAdZone = AdsNinjaRefreshingAdZone;
